module.exports = __webpack_public_path__ + "static/media/BG.212986b3.png";